import React from "react";
import "./styles.scss"

function AlertMaker({content}){
    return(
        <div className="alert-maker-root">
            {content}
        </div>
    )
}

export default AlertMaker